var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6287",
    "data-name": "Groupe 6287",
    transform: "translate(-0.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_449",
    "data-name": "Groupe 449",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    transform: "translate(0.471 0)",
    fill: "#d9fdf9",
    stroke: "#3ac1ae",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 43.5,
    r: 43,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5586",
    "data-name": "Trac\\xE9 5586",
    d: "M42.946,15.559a3.044,3.044,0,0,0-2.665-1.892l-11.145-1.62L24.153,1.95A3.045,3.045,0,0,0,21.53,0a3.045,3.045,0,0,0-2.623,1.95l-4.984,10.1L2.779,13.668A3.044,3.044,0,0,0,.114,15.559a3.045,3.045,0,0,0,1.044,3.1l8.065,7.86-1.9,11.1a3.207,3.207,0,0,0,.562,2.734,2.413,2.413,0,0,0,1.883.844,3.885,3.885,0,0,0,1.8-.494l9.968-5.241L31.5,40.7a3.89,3.89,0,0,0,1.8.495h0a2.412,2.412,0,0,0,1.883-.844,3.205,3.205,0,0,0,.562-2.734l-1.9-11.1,8.064-7.86a3.045,3.045,0,0,0,1.044-3.1m-2.8,1.29L31.6,25.173a1.261,1.261,0,0,0-.362,1.117l2.015,11.754a1.553,1.553,0,0,1,.01.627,1.549,1.549,0,0,1-.593-.2L22.118,32.917a1.263,1.263,0,0,0-1.174,0L10.388,38.467a1.555,1.555,0,0,1-.593.2,1.547,1.547,0,0,1,.01-.627L11.822,26.29a1.263,1.263,0,0,0-.363-1.117L2.92,16.85a1.556,1.556,0,0,1-.377-.5,1.55,1.55,0,0,1,.6-.184l11.8-1.715a1.262,1.262,0,0,0,.95-.69L21.17,3.066a1.549,1.549,0,0,1,.36-.513,1.546,1.546,0,0,1,.36.513l5.278,10.693a1.263,1.263,0,0,0,.95.69l11.8,1.715a1.553,1.553,0,0,1,.6.184,1.562,1.562,0,0,1-.377.5",
    transform: "translate(22.446 23.379)",
    fill: "#3ac1ae"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.b1b179ab7366cd470bd26ada3200fdc2.svg";
export { ForwardRef as ReactComponent };